import { Spin } from "antd";
import { Card, Col } from "reactstrap";
import UserCardBody from "./UserCardBody";
import UserCardHeader from "./UserCardHeader";

const TotalUserCard = ({ allStudents, loading }) => {
  const byFriend = "Recommended by friend or our student";
  const bySocialMedia = "Social Media (Facebook/Twitter/Youtube)";
  const total = allStudents?.length;

  const fromFriend = allStudents?.filter(s => s.howYouKnow === byFriend).length;
  const fromSocialMedia = allStudents?.filter(s => s.howYouKnow === bySocialMedia).length;

  const isValidSeries = fromFriend !== undefined && fromSocialMedia !== undefined;

  const percentFromFriend = isValidSeries ? parseFloat(((fromFriend / total) * 100).toFixed(2)) : 0;
  const percentFromSocialMedia = isValidSeries ? parseFloat(((fromSocialMedia / total) * 100).toFixed(2)) : 0;

  const chartSeries = isValidSeries ? [fromFriend, fromSocialMedia] : [0, 0];

  return (
    <Col xl="4" md="6" xxl="3" className="dash-30 box-col-35">
      <Card className="our-user relative">
        {loading && <div className={`charts-initial-loading`}><Spin /></div>}
        <UserCardHeader totalStudents={total} />
        <UserCardBody chartSeries={chartSeries} percentages={[percentFromFriend, percentFromSocialMedia]} />
      </Card>
    </Col>
  );
};

export default TotalUserCard;
